/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddInventoryDto as DigiworkMaitreDPosDtoInventoryAddInventoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Inventory/add-inventory-dto';
import { InventoryDto as DigiworkMaitreDPosDtoInventoryInventoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';

export interface AddInventory$Params {
      body?: DigiworkMaitreDPosDtoInventoryAddInventoryDto
}

export function addInventory(http: HttpClient, rootUrl: string, params?: AddInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>> {
  const rb = new RequestBuilder(rootUrl, addInventory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>;
    })
  );
}

addInventory.PATH = '/api/inventories';
